import { useGetFavicon } from '../hooks/use-get-fav';

export function FaviconSetter() {
  useGetFavicon();
  return null;
} 